export interface AzureSearchService {
  Name: string;
  ResourceGroup: string;
  Subscription: string;
  ProductID: string;
  AzureRegion: string;
}

export enum MenuType {
  Edit = 'edit',
  Delete = 'delete',
}
export interface AzureSearchServiceMenuItems {
  id: string;
  label: string;
  getLink?: (name: string) => string;
  validationFunc: MenuType;
}
